/**
 * This is intended only for INTLX Team
 * By design, this requires the page to have a script
 * tag of type "application/json" with the id of "js-config".
 */

import { usePageDataStore } from '@mc/globalStore';
import { getMergedReactTranslations } from './localeUtils';

const TRANSLATION_ELEMENT_ID = 'js-translation-data';
let translations = {};

/**
 * Parse and update the translations object using data stored in the html on page load,
 * When parsed, the data is removed from the html to reduce page size
 *
 * @param {?Object} optionalTranslations - Translation key values to apply over existing translation values
 * @returns {void}
 */
export function updateTranslations(optionalTranslations = null) {
  if (optionalTranslations) {
    translations = { ...translations, ...optionalTranslations };
    return;
  }

  let configElement;
  try {
    configElement = document.getElementById(TRANSLATION_ELEMENT_ID);
    if (configElement?.textContent) {
      translations = {
        ...translations,
        ...JSON.parse(configElement.textContent),
      };
      configElement.innerText = '';
    }
  } catch {
    if (__DEV__ && configElement) {
      throw new Error(
        '@mc/translation-data: Expected JSON, received: ' +
          configElement.textContent,
      );
    } else if (__DEV__) {
      throw new Error('@mc/translation-data: Translations Element not found');
    }
  }
}

/**
 * Return the currently available translations for the current page,
 * If not yet available, update then return the translations object
 *
 * @returns {?Object}
 */
export function readTranslations() {
  if (Object.keys(translations).length) {
    return translations;
  }
  updateTranslations();
  return translations;
}

// Flagged functions
export async function updateTranslationsFlagged(optionalTranslations = null) {
  if (optionalTranslations) {
    translations = { ...translations, ...optionalTranslations };
    return;
  }

  let configElement;
  try {
    const locale = usePageDataStore.getState().userData.locale;
    const translationData = await getMergedReactTranslations(locale);
    translations = {
      ...translations,
      ...translationData,
    };
  } catch {
    if (__DEV__ && configElement) {
      throw new Error(
        '@mc/translation-data: Expected JSON, received: ' +
          configElement.textContent,
      );
    } else if (__DEV__) {
      throw new Error('@mc/translation-data: Translations Element not found');
    }
  }
}

/**
 * Return the currently available translations for the current page,
 * If not yet available, update then return the translations object
 *
 * @returns {?Object}
 */
export async function readTranslationsFlagged() {
  if (Object.keys(translations).length) {
    return translations;
  }
  await updateTranslationsFlagged();
  return translations;
}
